import { openDialog } from '@component/dialog';
import { openToast } from '@component/toast';
import { UserItem, HostChangeReason, UserInfoItem } from '@tencent/wemeet-websdk-next';
import wemeetClient from '@utils/wemeetClient';
import { Translation } from 'react-i18next';

interface HostChangeData {
  '@xmlns': string;
  id: UserItem;
  meeting_code: string;
  meeting_id: string;
  reason: HostChangeReason;
  old_host: UserInfoItem;
}

export const hostChangeHandler = (data: HostChangeData) => {
  if (!data) return;
  const reason = data?.reason ?? HostChangeReason.CREATOR_RECYCLE;
  const oldHost = data.old_host;
  // 当前列表里的主持人是不是自己
  const selfIsHost = oldHost?.isSelf;
  const selfId = wemeetClient.userCtrl.getSelfId();
  const isNewHostIsSelf = selfId['@app_uid'] === data.id['@app_uid'];

  if (!selfIsHost && !isNewHostIsSelf) {
    // 不是旧主持人 也不是新主持人，直接返回
    return;
  }
  if (isNewHostIsSelf) {
    // 主持人是自己

    switch (Number(reason)) {
      case HostChangeReason.BY_HOST:
        openDialog({
          dialogId: 'becomeHostByHost',
          title: <Translation>{(t) => t('你已成为主持人')}</Translation>,
          content: (
            <Translation>
              {(t) => t('{#nickname#}已将主持人权限转交给你', { nickname: oldHost?.nickname ?? '' })}
            </Translation>
          ),
          btnConfigs: [
            {
              text: <Translation>{(t) => t('我知道了')}</Translation>,
              type: 'primary',
            },
          ],
        });
        break;
      case HostChangeReason.HOST_LEAVE:
        openDialog({
          dialogId: 'becomeHostByHostLeave',
          title: <Translation>{(t) => t('你已成为主持人')}</Translation>,
          content: <Translation>{(t) => t('主持人离开会议，你已成为主持人')}</Translation>,
          btnConfigs: [
            {
              text: <Translation>{(t) => t('我知道了')}</Translation>,
              type: 'primary',
            },
          ],
        });
        break;
      default:
        openToast(<Translation>{(t) => t('你已成为主持人')}</Translation>);
        break;
    }
  } else {
    // 失去主持人
    switch (Number(reason)) {
      // 主持人移交给了别人
      case HostChangeReason.BY_HOST:
        openToast(<Translation>{(t) => t('移交成功')}</Translation>);
        break;

      case HostChangeReason.CREATOR_RECYCLE:
        // 主持人收回
        openToast(
          <Translation>{(t) => t('{#nickname#}已成为主持人', { nickname: oldHost?.nickname ?? '' })}</Translation>,
        );
        break;
      default:
        break;
    }
  }
};
